<template>
  <div
    ref="wrapper"
    class="wrapper"
  >
    <svg
      ref="svg"
      v-resize="debounceOnResize"
    />
  </div>
</template>

<script>
import { LineChart } from '@/helpers/LineChart'
import debounce from '@/helpers/debounce'
import { seriesColors } from '@/helpers/chartColors'

export default {
  props: {
    data: Array,
  },
  watch: {
    data(newVal) {
      this.chart.update(newVal)
    },
  },
  mounted() {
    // const data = [
    //   {date: '2017-04-23', value: 43.24},
    //   {date: '2017-04-24', value: 75.35},
    //   {date: '2017-04-25', value: 98.84},
    //   {date: '2017-04-26', value: 104},
    //   {date: '2017-04-27', value: 97},
    //   {date: '2017-04-28', value: 114},
    // ].map(d => ({
    //   date: new Date(Date.UTC(
    //     d.date.substring(0, 4),
    //     d.date.substring(5, 7),
    //     d.date.substring(8, 10)
    //   )),
    //   value: d.value
    // }))
    // this.chart = new LineChart(this.$refs.svg, data)
    console.log('wrapper width:', this.$refs.wrapper.clientWidth)
    const width = this.$refs.wrapper.clientWidth
    // const height = width * 0.75
    const height = this.$refs.wrapper.clientHeight
    this.chart = new LineChart(this.$refs.svg, this.data, { width, height, colors: seriesColors, fillOpacity: 0.1 })
  },
  methods: {
    resize() {
      // this.chart.resize(this.$refs.wrapper.clientWidth, this.$refs.wrapper.clientWidth * 0.75)
      this.chart.resize(this.$refs.wrapper.clientWidth, this.$refs.wrapper.clientHeight)
    },
    debounceOnResize: debounce(function () {
      this.resize()
    }, 300),
    // onResize() {
    //   if (this.chart) {
    //     console.log('onResize')
    //     debounce(
    //       () => this.chart.resize(this.$refs.wrapper.clientWidth, this.$refs.wrapper.clientWidth * 0.75),
    //       300
    //     )
    //   }
    // },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}

svg {
  display: block;
}
</style>